var map = {
	"./Amex.svg": 1318,
	"./Apple.svg": 1319,
	"./Arrow-Coverage-Dark.svg": 1320,
	"./Arrow-Coverage-Light.svg": 1321,
	"./Arrow-Coverage.svg": 1322,
	"./Arrow-Element.svg": 1323,
	"./Arrow-Macro-Light.svg": 1324,
	"./Arrow-Macro.svg": 1325,
	"./Arrow-Micro-Dark.svg": 1326,
	"./Arrow-Micro.svg": 1327,
	"./Auth.svg": 1328,
	"./Close-Dark.svg": 1329,
	"./Close-Light.svg": 1330,
	"./Coverage-Dark.svg": 1331,
	"./Coverage-Light.svg": 1332,
	"./Credit-Card.svg": 1333,
	"./Data-Dark-16.svg": 1334,
	"./Data-Dark.svg": 1335,
	"./Data-Light-16.svg": 1336,
	"./Data-Light.svg": 1337,
	"./Down-Arrow.svg": 1338,
	"./Facebook-Original.svg": 1339,
	"./Footer-Amex.svg": 1340,
	"./Footer-Arrow-Close.svg": 1341,
	"./Footer-Arrow-Open.svg": 1342,
	"./Footer-Facebook.svg": 1343,
	"./Footer-Instagram.svg": 1344,
	"./Footer-Linkedin.svg": 1345,
	"./Footer-MasterCard.svg": 1346,
	"./Footer-Paypal.svg": 1347,
	"./Footer-Twitter.svg": 1348,
	"./Footer-VK.svg": 1349,
	"./Footer-Visa.svg": 1350,
	"./Footer-X.svg": 1351,
	"./GooglePlayStore.svg": 1352,
	"./ID.svg": 1353,
	"./Information.svg": 1354,
	"./Inline-American-Express.svg": 1355,
	"./Inline-MasterCard.svg": 1356,
	"./Inline-Unionpay.svg": 1357,
	"./Inline-Visa.svg": 1358,
	"./Input-Search-Dark.svg": 1359,
	"./Input-Search-Light.svg": 1360,
	"./Linkedin-Light.svg": 1361,
	"./Log-out-red.svg": 1362,
	"./Log-out.svg": 1363,
	"./Logo.svg": 1364,
	"./Manual-Install.svg": 1365,
	"./Mastercard.svg": 1366,
	"./PayPal.svg": 1367,
	"./Plus.svg": 1368,
	"./Price-Dark.svg": 1369,
	"./Price-Light.svg": 1370,
	"./QR.svg": 1371,
	"./Readonly-Input-Lock.svg": 1372,
	"./Saved-Amex.svg": 1373,
	"./Saved-MasterCard.svg": 1374,
	"./Saved-Visa.svg": 1375,
	"./Search.svg": 1376,
	"./Secure-Auth.svg": 1377,
	"./Secure-W.svg": 1378,
	"./Secure.svg": 1379,
	"./Share.svg": 1380,
	"./Star_color.svg": 1381,
	"./Store-Active-Dark.svg": 1382,
	"./Store-Active-Light.svg": 1383,
	"./Store-B.svg": 1384,
	"./Store-Inactive.svg": 1385,
	"./Store-W.svg": 1386,
	"./Store.svg": 1387,
	"./Success.svg": 1388,
	"./Trash.svg": 1389,
	"./Twitter-Original.svg": 1390,
	"./User-Active-Dark.svg": 1391,
	"./User-Active-Light.svg": 1392,
	"./User-Inactive.svg": 1393,
	"./Validity-Dark.svg": 1394,
	"./Validity-Light.svg": 1395,
	"./Visa.svg": 1396,
	"./What-is-This.svg": 1397,
	"./copy.svg": 1398,
	"./eSIM-Active-Dark.svg": 1399,
	"./eSIM-Active-Light.svg": 1400,
	"./eSIM-Dark.svg": 1401,
	"./eSIM-Inactive.svg": 1402,
	"./eSIM-Light.svg": 1403,
	"./email.svg": 1404,
	"./facebook.svg": 1405,
	"./ic_add-card.svg": 1406,
	"./ic_airmoney_macro.svg": 911,
	"./ic_airmoney_micro.svg": 1407,
	"./ic_airmoney_pay.svg": 1408,
	"./ic_airmoney_payment-method.svg": 1409,
	"./ic_alipay_payment-method-dark.svg": 1410,
	"./ic_alipay_payment-method-light.svg": 1411,
	"./ic_amex.svg": 1412,
	"./ic_apple-dark.svg": 1413,
	"./ic_apple-light.svg": 1414,
	"./ic_apple-pay_payment-method.svg": 1415,
	"./ic_arrow_slider_active_Light.svg": 1416,
	"./ic_arrow_slider_inactive_Light.svg": 1417,
	"./ic_back_header-dark.svg": 1418,
	"./ic_back_header-light.svg": 1419,
	"./ic_banner_refeere.svg": 1420,
	"./ic_banner_referrer.svg": 1421,
	"./ic_bill_to_org_payment-method-light.svg": 1422,
	"./ic_calls.svg": 1423,
	"./ic_checkbox_active.svg": 1424,
	"./ic_checkbox_inactive.svg": 1425,
	"./ic_chevron-right.svg": 1426,
	"./ic_chip.svg": 1427,
	"./ic_clear.svg": 1428,
	"./ic_close_white.svg": 1429,
	"./ic_copy.svg": 1430,
	"./ic_coverage.svg": 1431,
	"./ic_credit-card_payment-method-dark.svg": 1432,
	"./ic_credit-card_payment-method-light.svg": 1433,
	"./ic_data.svg": 1434,
	"./ic_delete_white.svg": 1435,
	"./ic_discount-code.svg": 1436,
	"./ic_edit_white.svg": 1437,
	"./ic_esim.svg": 1438,
	"./ic_expire.svg": 1439,
	"./ic_fup.svg": 1440,
	"./ic_google-pay.svg": 1441,
	"./ic_google-pay_payment-method.svg": 1442,
	"./ic_google.svg": 1443,
	"./ic_help_center.svg": 1444,
	"./ic_install.svg": 1445,
	"./ic_jcb.svg": 1446,
	"./ic_logout.svg": 1447,
	"./ic_long-back-arrow.svg": 1448,
	"./ic_manual_install.svg": 1449,
	"./ic_mastercard.svg": 1450,
	"./ic_notification.svg": 1451,
	"./ic_package.svg": 1452,
	"./ic_paypal_payment-method-dark.svg": 1453,
	"./ic_paypal_payment-method-light.svg": 1454,
	"./ic_play.svg": 1455,
	"./ic_price.svg": 1456,
	"./ic_price_v2.svg": 912,
	"./ic_qrcode_install.svg": 1457,
	"./ic_routing.svg": 1458,
	"./ic_screenshot.svg": 1459,
	"./ic_sms.svg": 1460,
	"./ic_statistic.svg": 1461,
	"./ic_store_header.svg": 1462,
	"./ic_stripe.svg": 1463,
	"./ic_subscription.svg": 1464,
	"./ic_success.svg": 1465,
	"./ic_success_banner.svg": 1466,
	"./ic_success_order-completed.svg": 1467,
	"./ic_telegram.svg": 1468,
	"./ic_tips.svg": 1469,
	"./ic_unionpay.svg": 1470,
	"./ic_validity.svg": 1471,
	"./ic_visa.svg": 1472,
	"./ic_visa_payment-method.svg": 1473,
	"./ic_visa_saved-card.svg": 1474,
	"./ic_whatsapp.svg": 1475,
	"./icon-ekyc-detail-card-info.svg": 1476,
	"./icon-ekyc-detail-driver-license.svg": 1477,
	"./icon-ekyc-detail-faq-arrow.svg": 1478,
	"./icon-ekyc-detail-finger-print.svg": 1479,
	"./icon-ekyc-detail-identity-card.svg": 1480,
	"./icon-ekyc-detail-jumio.svg": 1481,
	"./icon-ekyc-detail-passport.svg": 1482,
	"./icon-esim-detail-copy-dark.svg": 1483,
	"./icon-esim-detail-copy-light.svg": 1484,
	"./icon-esim-detail-coverage-arrow-dark.svg": 1485,
	"./icon-esim-detail-coverage-arrow-light.svg": 1486,
	"./icon-esim-detail-error-text-field-dark.svg": 1487,
	"./icon-esim-detail-error-text-field-light.svg": 1488,
	"./icon-header-airmoney.svg": 1489,
	"./icon-header-arrow-close.svg": 1490,
	"./icon-header-language.svg": 1491,
	"./icon-header-myesim.svg": 1492,
	"./icon-header-profile.svg": 1493,
	"./icon-header-store.svg": 1494,
	"./icon-hero-rating-appstore.svg": 1495,
	"./icon-hero-rating-googleplay.svg": 1496,
	"./icon-homepage-country-arrow-close.svg": 1497,
	"./icon-homepage-country-arrow-open.svg": 1498,
	"./icon-homepage-country-data-dark-16.svg": 1499,
	"./icon-homepage-country-data-dark-22.svg": 1500,
	"./icon-homepage-country-data-light-16.svg": 1501,
	"./icon-homepage-country-data-light-22.svg": 1502,
	"./icon-info-general-dark.svg": 1503,
	"./icon-info-general-light.svg": 1504,
	"./icon-mob-website-expansion-item-arrow.svg": 1505,
	"./icon-myesims-checklist.svg": 1506,
	"./icon-myesims-nosign.svg": 1507,
	"./icon-myesims-trash-slash.svg": 1508,
	"./icon-myesims-wifi-exclamationmark.svg": 1509,
	"./icon-orders-billed-to.svg": 1510,
	"./icon-package-3g-light.svg": 1511,
	"./icon-package-4g-light.svg": 1512,
	"./icon-package-5g-light.svg": 1513,
	"./icon-package-activation-policy-light.svg": 1514,
	"./icon-package-arrow-general-light.svg": 1515,
	"./icon-package-calling-credit-light.svg": 1516,
	"./icon-package-coverage-dark.svg": 1517,
	"./icon-package-coverage-light.svg": 1518,
	"./icon-package-ekyc-micro-light.svg": 1519,
	"./icon-package-ekyc-restriction-light.svg": 1520,
	"./icon-package-ekyc-validation-light.svg": 1521,
	"./icon-package-fup-dark.svg": 1522,
	"./icon-package-fup-light.svg": 1523,
	"./icon-package-info-general-light.svg": 1524,
	"./icon-package-lte-light.svg": 1525,
	"./icon-package-network-light.svg": 1526,
	"./icon-package-plan-type-light.svg": 1527,
	"./icon-package-price-dark.svg": 1528,
	"./icon-package-price-light.svg": 1529,
	"./icon-package-supported-arrow-dark.svg": 1530,
	"./icon-package-supported-arrow-light.svg": 1531,
	"./icon-package-topup-option-light.svg": 1532,
	"./icon-package-validity-dark.svg": 1533,
	"./icon-package-validity-light.svg": 1534,
	"./icon-partner-with-us-breadcrumb-arrow.svg": 1535,
	"./icon-password-hidden-error.svg": 1536,
	"./icon-password-hidden.svg": 1537,
	"./icon-password-visible-error.svg": 1538,
	"./icon-password-visible.svg": 1539,
	"./icon-search-clear.svg": 1540,
	"./icon-search.svg": 1541,
	"./icon-unlimited-dark.svg": 1542,
	"./icon-unlimited-light.svg": 1543,
	"./icon-website-expansion-content-box-bg-sm.svg": 1544,
	"./icon-website-expansion-content-box-bg.svg": 1545,
	"./mail.svg": 1546,
	"./order-async/my-esims/top-up-is-delayed.svg": 1547,
	"./order-async/my-esims/top-up-is-failed.svg": 1548,
	"./order-async/my-esims/top-up-is-on-the-way.svg": 1549,
	"./settings_button.svg": 1550,
	"./tabs-Airmoney.svg": 1551,
	"./tabs-Credit-Card.svg": 1552,
	"./tabs-PayPal.svg": 1553,
	"./telegram.svg": 1554,
	"./tick-light.svg": 1555,
	"./twitter.svg": 1556,
	"./whatsapp.svg": 1557
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 908;